import type { Context, Provider } from 'react';
import { createContext, useContext } from 'react';

import type { OmnibarEligibilityResult } from './hooks/useOmnibarEligibility.ts';

const defaultEligibility: OmnibarEligibilityResult = {
	showReactions: false,
	showComments: false,
};

/**
 * Context for OmniBar eligibility so the experiment is read only once (in ViewPageCommon).
 */
export const OmnibarEligibilityContext: Context<OmnibarEligibilityResult> =
	createContext<OmnibarEligibilityResult>(defaultEligibility);

export const OmnibarEligibilityProvider: Provider<OmnibarEligibilityResult> =
	OmnibarEligibilityContext.Provider;

export const useOmnibarEligibilityFromContext = (): OmnibarEligibilityResult =>
	useContext(OmnibarEligibilityContext);
